import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter } from '@cmg/data-grid';

import type { FirmSalesCoverageGridItemFragment } from '../graphql/__generated__';

const valueFormatter = createValueFormatter<
  FirmSalesCoverageGridItemFragment,
  FirmSalesCoverageGridItemFragment['employeeName']
>();

export const employeeNameColDef: ServerColDef<FirmSalesCoverageGridItemFragment> = {
  field: 'employeeName',
  headerName: 'Employee Name',
  valueFormatter,
};
